import React, { useState } from 'react'
import { Alert } from 'antd'
import { Detector } from 'react-detect-offline'

function OfflineDetector () {
  const [online, setOnline] = useState(true)
  return (
    <Detector
      onChange={setOnline}
      polling={{ url: '/', enabled: true, interval: 60000 }}
      render={() =>
        !online && (
          <Alert
            type={'error'}
            description={
              <span>
                please check your network connection or <strong>VPN </strong>
                connection
              </span>
            }
            message={
              <span>
                You are <strong>offline</strong>
              </span>
            }
          />
        )
      }
    />
  )
}

OfflineDetector.propTypes = {}
OfflineDetector.defaultProps = {}

export default (OfflineDetector)
